import React from "react";

// Selectable pill chip used for filters and tags.
export default function FilterChip({
  active = false,
  onClick,
  children,
  className = "",
  as = "button",
  testId,
}) {
  const cls = `inline-flex items-center gap-1.5 rounded-pill px-4 py-2 text-sm font-semibold ink-border transition-colors duration-200 ${
    active ? "bg-purple text-warm border-purple" : "bg-warm text-ink hover:bg-cream-2"
  } ${className}`;

  if (as === "span") {
    return (
      <span className={cls} data-testid={testId}>
        {children}
      </span>
    );
  }
  return (
    <button type="button" onClick={onClick} className={cls} data-testid={testId}>
      {children}
    </button>
  );
}
